import { render, staticRenderFns } from "./group-status-link-form.vue?vue&type=template&id=641005a1"
import script from "./group-status-link-form.vue?vue&type=script&lang=js"
export * from "./group-status-link-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports